const BASE_URL = '/Kiosk'

export const getBackground = async (reqBody) => {
    try {
        const res = await fetch(`${BASE_URL}/RetrieveBackgroundImage`, {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
            }),
            credentials: 'include',
            body: JSON.stringify(reqBody)
        })
        return await res.json()
    } catch (error) {
        throw error
    }
}

export const getHeader = async (reqBody) => {
    try {
        const res = await fetch(`${BASE_URL}/RetrieveHeaderImage`, {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
            }),
            credentials: 'include',
            body: JSON.stringify(reqBody)
        })
        return await res.json()
    } catch (error) {
        throw error
    }
}

export const getSponsor = async (reqBody) => {
    try {
        const res = await fetch(`${BASE_URL}/RetrieveSponsorImage`, {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
            }),
            credentials: 'include',
            body: JSON.stringify(reqBody)
        })
        return await res.json()
    } catch (error) {
        throw error
    }
}

export const getSetting = async (reqBody) => {
    try {
        const res = await fetch(`${BASE_URL}/RetrieveKioskSetting`, {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
            }),
            credentials: 'include',
            body: JSON.stringify(reqBody)
        })
        return await res.json()
    } catch (error) {
        throw error
    }
}

export const getScannerSetting = async (reqBody) => {
    try {
        const res = await fetch(`${BASE_URL}/RetrieveKioskScannerSetting`, {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
            }),
            credentials: 'include',
            body: JSON.stringify(reqBody)
        })
        return await res.json()
    } catch (error) {
        throw error
    }
}
export const getLandingSetting = async (reqBody) => {
    try {
        const res = await fetch(`${BASE_URL}/RetrieveKioskLandingSetting`, {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
            }),
            credentials: 'include',
            body: JSON.stringify(reqBody)
        })
        return await res.json()
    } catch (error) {
        throw error
    }
}
export const getSmallAttendeesSearchPaged = async (reqBody) => {
    try {
        const res = await fetch(`${BASE_URL}/SmallAttendeeBadgeSearchPaged`, {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
            }),
            credentials: 'include',
            body: JSON.stringify(reqBody)
        })
        if (res.status === 204) {
            return null
        }
        else if (res.status === 200) {
            return await res.json()
        }
        return await res.json()
    } catch (error) {
        throw error
    }
}

export const getSmallAttendeesWithGuestsSearchPaged = async (reqBody) => {
    try {
        const res = await fetch(`${BASE_URL}/SmallAttendeesWithGuestsSearchPaged`, {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
            }),
            credentials: 'include',
            body: JSON.stringify(reqBody)
        })
        if (res.status === 204) {
            return null
        }
        else if (res.status === 200) {
            return await res.json()
        }
        return await res.json()
    } catch (error) {
        throw error
    }
}


export const getAttendeesSearchPaged = async (reqBody) => {
    try {
        const res = await fetch(`${BASE_URL}/RetrieveAttendeesBadges`, {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
            }),
            credentials: 'include',
            body: JSON.stringify(reqBody)
        })
        return await res.json()
    } catch (error) {
        throw error 
    }
}
export const getAttendeesWithGuestsSearchPaged = async (reqBody) => {
    try {
        const res = await fetch(`${BASE_URL}/RetrieveAttendeesWithGuests`, {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
            }),
            credentials: 'include',
            body: JSON.stringify(reqBody)
        })
        return await res.json()
    } catch (error) {
        throw error
    }
}
export const getAttendeeIdsSearchPaged = async (reqBody) => {
    try {
        const res = await fetch(`${BASE_URL}/AttendeeBadgeIdSearchPaged`, {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
            }),
            credentials: 'include',
            body: JSON.stringify(reqBody)
        })
        return await res.json()
    } catch (error) {
        throw error
    }
}

export const getAttendeeRegistrationTypesSearchPaged = async (reqBody) => {
    try {
        const res = await fetch(`${BASE_URL}/AttendeeBadgeRegistrationTypeSearchPaged`, {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
            }),
            credentials: 'include',
            body: JSON.stringify(reqBody)
        })
        return await res.json()
    } catch (error) {
        throw error
    }
}
export const getAttendeesPaidAfterSearchPaged = async (reqBody) => {
    try {
        const res = await fetch(`${BASE_URL}/AttendeesBadgePaidAfterSearchPaged`, {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
            }),
            credentials: 'include',
            body: JSON.stringify(reqBody)
        })
        return await res.json()
    } catch (error) {
        throw error
    }
}
export const getAttendeeOrganizationsSearchPaged = async (reqBody) => {
    try {
        const res = await fetch(`${BASE_URL}/AttendeeBadgeOrganizationSearchPaged`, {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
            }),
            credentials: 'include',
            body: JSON.stringify(reqBody)
        })
        return await res.json()
    } catch (error) {
        throw error
    }
}
export const getAttendeesOrganizationsSearchPaged = async (reqBody) => {
    try {
        const res = await fetch(`${BASE_URL}/AttendeesBadgeOrganizationSearchPaged`, {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
            }),
            credentials: 'include',
            body: JSON.stringify(reqBody)
        })
        return await res.json()
    } catch (error) {
        throw error
    }
}
export const getAttendeesNotPrintedSearchPaged = async (reqBody) => {
    try {
        const res = await fetch(`${BASE_URL}/AttendeesBadgeNotPrintedSearchPaged`, {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
            }),
            credentials: 'include',
            body: JSON.stringify(reqBody)
        })
        if (res.status !== 200) {
            return null
        }
        else {
            return await res.json()
        }
    } catch (error) {
        throw error
    }
}

export const getAttendeesWithGuestsNotPrintedSearchPaged = async (reqBody) => {
    try {
        const res = await fetch(`${BASE_URL}/AttendeesWithGuestsNotPrintedSearchPaged`, {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
            }),
            credentials: 'include',
            body: JSON.stringify(reqBody)
        })
        if (res.status !== 200) {
            return null
        }
        else {
            return await res.json()
        }
    } catch (error) {
        throw error
    }
}

export const getAttendeesByFieldSearch = async (reqBody) => {
    try {
        const res = await fetch(`${BASE_URL}/AttendeesByFieldSearch`, {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
            }),
            credentials: 'include',
            body: JSON.stringify(reqBody)
        })
        return await res.json()
    } catch (error) {
        throw error
    }
}
export const getAttendeesWithGuestsByFieldSearch = async (reqBody) => {
    try {
        const res = await fetch(`${BASE_URL}/AttendeesWithGuestsByFieldSearch`, {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
            }),
            credentials: 'include',
            body: JSON.stringify(reqBody)
        })
        if (res.status !== 200) {
            return null
        }
        else {
            return await res.json()
        }
    } catch (error) {
        throw error
    }
}

export const getFranky = async reqBody => {
    try {
        const res = await fetch(`${BASE_URL}/GetFrankyBadge`, {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
            }),
            credentials: 'include',
            body: JSON.stringify(reqBody)
        })
        return await res.json()
    } catch (error) {
        console.log(error)
        throw error
    }
}
export const getFrankyWithGuest = async reqBody => {
    try {
        const res = await fetch(`${BASE_URL}/GetFrankyBadgeWithGuest`, {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
            }),
            credentials: 'include',
            body: JSON.stringify(reqBody)
        })
        if (res.status !== 200) {
            return null
        }
        else {
            return await res.json()
        }
    } catch (error) {
        console.log(error)
        throw error
    }
}

export const getSmallAttendeesByFieldSearch = async (reqBody) => {
    try {
        const res = await fetch(`${BASE_URL}/SmallAttendeesByFieldSearch`, {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
            }),
            credentials: 'include',
            body: JSON.stringify(reqBody)
        })
        return await res.json()
    } catch (error) {
        throw error
    }
}
export const recordAttendeePrint = async (searchBody) => {
    try {
        const res = await fetch(`${BASE_URL}/RecordAttendeeBadgePrint`, {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
            }),
            credentials: 'include',
            body: JSON.stringify(searchBody)
        })
        //return await res.json()
        if (res.status === 204 || res.status === 200) {
            return "Success"
        }
        else {
            return "error"
        }
    } catch (error) {
        throw error
    }
}
export const recordAttendeesPrint = async (searchBody) => {
    try {
        const res = await fetch(`${BASE_URL}/RecordAttendeesBadgePrint`, {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
            }),
            credentials: 'include',
            body: JSON.stringify(searchBody)
        })
        //return await res.json()
        if (res.status === 204 || res.status === 200) {
            return "Success"
        }
        else {
            return "error"
        }
    } catch (error) {
        throw error
    }
}


export const recordAdHocPrint = async (searchBody) => {
    try {
        const res = await fetch(`${BASE_URL}/RecordAdHocPrint`, {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
            }),
            credentials: 'include',
            body: JSON.stringify(searchBody)
        })
        //return await res.json()
        if (res.status === 204 || res.status === 200) {
            return "Success"
        }
        else {
            return "error"
        }
    } catch (error) {
        throw error
    }
}

export const checkAttendeePrinted = async (searchBody) => {
    try {
        const res = await fetch(`${BASE_URL}/CheckAttendeeBadgePrint`, {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
            }),
            credentials: 'include',
            body: JSON.stringify(searchBody)
        })
        return await res.json()
    } catch (error) {
        throw error
    }
}


export const getImageByCSSFieldName = async (reqBody) => {
    try {
        const res = await fetch(`${BASE_URL}/RetrieveImageByCSSFieldName`, {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
            }),
            credentials: 'include',
            body: JSON.stringify(reqBody)
        })
        return await res.json()
    } catch (error) {
        throw error
    }
}

export const getTemplates = async (reqBody) => {
    try {
        const res = await fetch(`${BASE_URL}/RetrieveTemplates`, {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
            }),
            credentials: 'include',
            body: JSON.stringify(reqBody)
        })
        if (res.status === 204) {
            return null
        }
        else if (res.status === 200) {
            return await res.json()
        }
        return await res.json()
    } catch (error) {
        throw error
    }
}

export const getSizedImageByCSSFieldName = async (reqBody) => {
    try {
        const res = await fetch(`${BASE_URL}/RetrieveSizedImageByCSSFieldName`, {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
            }),
            credentials: 'include',
            body: JSON.stringify(reqBody)
        })
        //return await res.json()
        if (res.status === 204 || res.status === 200) {
            return "Success"
        }
        else {
            return "error"
        }
    } catch (error) {
        throw error
    }
}

export const getSizedFileByCSSFieldName = async (reqBody) => {
    try {
        const res = await fetch(`${BASE_URL}/RetrieveSizedFileByCSSFieldName`, {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
            }),
            credentials: 'include',
            body: JSON.stringify(reqBody)
        })
        return await res.json()
    } catch (error) {
        throw error
    }
}

export const getFileByCSSFieldName = async (reqBody) => {
    try {
        const res = await fetch(`${BASE_URL}/RetrieveFileByCSSFieldName`, {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
            }),
            credentials: 'include',
            body: JSON.stringify(reqBody)
        })
        return await res.json()
    } catch (error) {
        throw error
    }
}

export const getScannerPageSetting = async (reqBody) => {
    try {
        const res = await fetch(`${BASE_URL}/RetrieveScannerPageSetting`, {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
            }),
            credentials: 'include',
            body: JSON.stringify(reqBody)
        })
        return await res.json()
    } catch (error) {
        throw error
    }
}